import { ROLES_SPORT_OPTIONS } from "../../constants/config";

/**
 * Label italiana di un ruolo atleta (enum inglese nel DB, es. "winger" →
 * "Esterno"). Cerca in TUTTI gli sport: i valori enum sono univoci abbastanza
 * per l'uso display; fallback = valore raw.
 */
const ROLE_LABELS: Record<string, string> = Object.values(
  ROLES_SPORT_OPTIONS
).reduce<Record<string, string>>((acc, options) => {
  for (const opt of options as { value: string; label: string }[]) {
    if (!(opt.value in acc)) acc[opt.value] = opt.label;
  }
  return acc;
}, {});

export const roleLabel = (role?: string | null): string | null =>
  role ? (ROLE_LABELS[role] ?? role) : null;
